class ApiError {
  /**
   * @param code
   * @param message
   * @param {Localization} localization
   */
  constructor(code, message, localization) {
    this._code = code;
    this._message = message;
    this._localization = localization;
  }

  get code() {
    return this._code;
  }

  get message() {
    const key = `api-errors.${this._code}`;

    if (this._localization.translationExists(key)) {
      return this._localization.translate(key);
    }

    return this._message;
  }
}

module.exports = ApiError;
